module.exports = __webpack_public_path__ + "static/media/intero_vert.369827fd.svg";